import { createContext } from 'react';
const AdCampaignContext = createContext();
export default AdCampaignContext;
